import React from "react";
import PropTypes from "prop-types";

import { NestedDropDown } from "./NestedDropDown";

NestedDropDownComponent.propTypes = {
  data: PropTypes.any,
  width: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func,
  defaultValue: PropTypes.string,
};

export function NestedDropDownComponent(props) {
  const { data } = props;
  const { onSelect } = props;
  const { width } = props;
  const { label } = props;
const { defaultValue } = props;
  // Adapt the data here to match the JSON =>const adaptedData = mock.array;

  return (
    <NestedDropDown
      items={data}
      onSelect={onSelect}
      width={width}
      label={label}
      defaultValue={defaultValue}
    />
  );
}
